import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcronymIconComponent } from './acronym-icon.component';
import { PipesModule } from '../../common/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [AcronymIconComponent],
  imports: [CommonModule, PipesModule, MatTooltipModule],
  exports: [AcronymIconComponent],
})
export class AcronymIconModule {}
